import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from 'material-ui/styles';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';

import { arrayToObject } from '../../../lib/helpers';
import { extractMhzs } from '../../../lib/material';
import { mhz2label } from '../../../lib/unitConversions';
import { DK_DECIMALS, DF_DECIMALS } from '../../../constants/globals';
import { Material } from '../../../models';

const styles = function(theme){
  return {
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
    }
  }
}

export const MaterialDetail = ({ classes, material }) => {
  const { dk, df } = material;
  const MHZ = 'mhz';
  const dkObj = arrayToObject(dk, MHZ);
  const dfObj = arrayToObject(df, MHZ);
  const mhzs = extractMhzs([material], ['dk', 'df']);

  return (
    <Paper className={classes.root}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell />
            {mhzs.map(mhz => (
              <TableCell key={mhz} numeric>{mhz2label(mhz)}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Dk</TableCell>
            {mhzs.map(mhz => (
              <TableCell key={mhz} numeric>
                {dkObj[mhz].value.toFixed(DK_DECIMALS)}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell>Df</TableCell>
            {mhzs.map(mhz => (
              <TableCell key={mhz} numeric>
                {dfObj[mhz].value.toFixed(DF_DECIMALS)}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
};

MaterialDetail.propTypes = {
  classes:  PropTypes.shape({
    root: PropTypes.string
  }).isRequired,
  material: PropTypes.instanceOf(Material).isRequired,
}

export default withStyles(styles)(MaterialDetail);



// WEBPACK FOOTER //
// ./src/components/common/MaterialPanel/MaterialDetail.js